import React from 'react';
import ApplicationRouter from "./router/Router";
import './App.css';

function App() {
  return (
    <div className="App">
        <ApplicationRouter/>
    </div>
  );
}

export default App;
